import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../../src/MyPage";
import SubTabsParameters from "../../../src/SubTabsParameters";
import { isSuperAdmin } from "./../../helpers/user.js";
import { Blocks } from 'react-loader-spinner'
import axiosService from '../../helpers/axios';


  export default class ParametersContainerContent extends Component{ 

    constructor(props){
      super(props);

      this.state={
          containerscontent:[],
          modalTitle:"",
          product: {
            productid:0,
            sapcode:"",
            productdescription:""
            },
          numberitems:"",
          containercontentid:0,
          container: {
            containerid:0,
            containerdescription:""
            },

            productid: 0,
		        containerid: 0,

          ContainercontentIdFilter:"",
          NumberitemsFilter:"",
          ContainerIdFilter:"",
          ContainerDescriptionFilter:"",
          ProductIdFilter:"",
          ProductDescriptionFilter:"",
          containerscontentWithoutFilter:[],
          containerNames: [],
          productNames: [],
          isEditClicked: false, 
          loading: true,
          purchasedContainers : [],           
        
          containersvalues:[],
          containervalueid_o:0,
          yearid_o:0,
		      fyname_o: "",
          containerid_o:0,
		      containerdescription_o: "",
		      july_o: 0,
		      august_o: 0,
		      september_o: 0,
		      october_o: 0,
		      november_o: 0,
		      december_o: 0,
		      january_o: 0,
		      february_o: 0,
		      march_o: 0,
		      april_o: 0,
		      may_o: 0,
		      june_o: 0,
          FiscalYearNameOFilter:"",
          ContainerIdOFilter:"",
          ContainerDescriptionOFilter:"",
          containersvaluesWithoutFilter:[],
          SapcodeNames:[],
          containersPurchased:[]
      }
  }

  getCurrentFinancialYearAndMonth() {
    const today = new Date();
    let fiscalYear = "";
    let fiscalMonth = "";
  
    // Determine fiscal year
    if ((today.getMonth() + 1) <= 6) {
      fiscalYear = (today.getFullYear());
    } else {
      fiscalYear = today.getFullYear() + 1;
    }
  
    // Determine fiscal month
    fiscalMonth = (today.getMonth() + 1); // Adding 1 as months are 0-indexed
  
    return {
      fiscalYear: fiscalYear,
      fiscalMonth: fiscalMonth
    };
  }


  FilterFn(){
    var ContainercontentIdFilter=this.state.ContainercontentIdFilter;
    var NumberitemsFilter = this.state.NumberitemsFilter;
    var ContainerIdFilter = this.state.ContainerIdFilter;
    var ContainerDescriptionFilter = this.state.ContainerDescriptionFilter;
    var ProductIdFilter = this.state.ProductIdFilter;
    var ProductDescriptionFilter = this.state.ProductDescriptionFilter;

    var filteredData=this.state.containerscontentWithoutFilter.filter(
        function(el){
            return el.containercontentid.toString().toLowerCase().includes(
                ContainercontentIdFilter.toString().trim().toLowerCase()
            )&&
            el.containerid.toString().toLowerCase().includes(
              ContainerIdFilter.toString().trim().toLowerCase()
            )&&
            el.container?.containerdescription.toString().toLowerCase().includes(
              ContainerDescriptionFilter.toString().trim().toLowerCase()
            )&&
            el.product.sapcode.toString().toLowerCase().includes(
              ProductIdFilter.toString().trim().toLowerCase()
            )&&
            el.product?.productdescription.toString().toLowerCase().includes(
              ProductDescriptionFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({containerscontent:filteredData});

}

FilterFnContainerValue(){

  var FiscalYearNameOFilter = this.state.FiscalYearNameOFilter;
  var ContainerIdOFilter = this.state.ContainerIdOFilter;
  var ContainerDescriptionOFilter = this.state.ContainerDescriptionOFilter;

  var filteredDataContainerValue=this.state.containersvaluesWithoutFilter.filter(
    function(el){
        return el.fyname_o?.toString().toLowerCase().includes(
            FiscalYearNameOFilter.toString().trim().toLowerCase()
        )&&  
            el.containerid_o?.toString().toLowerCase().includes(
            ContainerIdOFilter.toString().trim().toLowerCase()
        )&&  
            el.containerdescription_o?.toString().toLowerCase().includes(
            ContainerDescriptionOFilter.toString().trim().toLowerCase()
        )
    }
);

  this.setState({containersvalues:filteredDataContainerValue});

}

sortResult(prop,asc){
  var sortedData=this.state.containerscontentWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({containerscontent:sortedData});

}


sortResultContainerValue(prop,asc){

  var sortedDataContainerValue=this.state.containersvaluesWithoutFilter.sort(function(a,b){
    if(asc){
        return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
    }
    else{
        return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
    }
});

  this.setState({containersvalues:sortedDataContainerValue});

}

changeContainercontentIdFilter = (e)=>{
  this.state.ContainercontentIdFilter=e.target.value;
  this.FilterFn();
}
changeNumberitemsFilter = (e)=>{
  this.state.NumberitemsFilter=e.target.value;
  this.FilterFn();
}

changeContainerIdFilter = (e)=>{
  this.state.ContainerIdFilter=e.target.value;
  this.FilterFn();
}

changeContainerDescriptionFilter = (e)=>{
  this.state.ContainerDescriptionFilter=e.target.value;
  this.FilterFn();
}

changeProductIdFilter = (e)=>{
  this.state.ProductIdFilter=e.target.value;
  this.FilterFn();
}

changeProductDescriptionFilter = (e)=>{
  this.state.ProductDescriptionFilter=e.target.value;
  this.FilterFn();
}


changeFiscalYearNameOFilter = (e)=>{
  this.state.FiscalYearNameOFilter=e.target.value;
  this.FilterFnContainerValue();
}

changeContainerIdOFilter = (e)=>{
  this.state.ContainerIdOFilter=e.target.value;
  this.FilterFnContainerValue();
}

changeContainerDescriptionOFilter = (e)=>{
  this.state.ContainerDescriptionOFilter=e.target.value;
  this.FilterFnContainerValue();
}



refreshList = () => {
  axiosService.get('/containerscontent/')
    .then((response) => {
      const data = response.data?.results ?? response.data;
      this.setState({ containerscontent: data, containerscontentWithoutFilter: data, loading: false });
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
      this.setState({ loading: false });
    });
};

refreshListContainersValues = () => {
  axiosService.get('/containersvalues/')
    .then((response) => {
      const data = response.data?.results ?? response.data;
      this.setState({ containersvalues: data, containersvaluesWithoutFilter: data, loading: false });
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
      this.setState({ loading: false });
    });
};

fetchContainerNames() {
  axiosService.get('/containers/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const containerNames = filteredData.map(item => item.containerdescription);
      this.setState({ containerNames: containerNames });
    })
    .catch(error => {
      console.error("Error fetching container names:", error);
    });
}


fetchProductNames() {
  axiosService.get('/defaultproducts/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const productNames = filteredData.map(item => item.productdescription);
      this.setState({ productNames: productNames });
    })
    .catch(error => {
      console.error("Error fetching product names:", error);
    });
}



fetchContainersPurchased() {
  //const currentYear = fiscalYears[currentYearIndex];
const { fiscalYear, fiscalMonth } = this.getCurrentFinancialYearAndMonth();
const selectedFiscalYear = parseInt(this.state.fyname, 10);
const isDisabledYear = fiscalYear > selectedFiscalYear;
axiosService.get('/purchases/')
  .then(response => {
    const data = response.data?.results ?? response.data;
    const pastYearsPurchases = data.filter(item => item.year.fyname < fiscalYear);
    const regionNames = data.map(item => item.regionname);
    this.setState({ containersPurchased: regionNames });
  })
  .catch(error => {
    console.error("Error fetching purchases:", error);
  });
}


fetchPurchasedContainers() {
  axiosService.get('/purchases/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const { fiscalYear, fiscalMonth } = this.getCurrentFinancialYearAndMonth();
      const selectedFiscalYear = parseInt(this.state.fyname, 10);
      const selectedMonthIsJuly = parseInt(7, 10);
      const selectedMonthIsAugust = parseInt(8, 10);
      const selectedMonthIsSeptember = parseInt(9, 10);
      const selectedMonthIsOctober = parseInt(10, 10);
      const selectedMonthIsNovember = parseInt(11, 10);
      const selectedMonthIsDecember = parseInt(12, 10);
    
      const selectedMonthIsJanuary = parseInt(1, 10);
      const selectedMonthIsFebruary = parseInt(2, 10);
      const selectedMonthIsMarch = parseInt(3, 10);
      const selectedMonthIsApril = parseInt(4, 10);
      const selectedMonthIsMay = parseInt(5, 10);
      const selectedMonthIsJune = parseInt(6, 10);

      const isDisabledYear = fiscalYear > selectedFiscalYear;
      const isBetweenJulyAndDecember =
      fiscalMonth >= 7 && fiscalMonth <= 12; // Check if fiscal month is between July (6) and November (11) inclusive
      const isBetweenJanuaryAndJune =
      fiscalMonth >= 1 && fiscalMonth <= 6;
  
const isYearCanBeDisable = selectedFiscalYear <= fiscalYear ; // Check if it's the selected fiscal year

const isPassedMonthJuly = (fiscalMonth > selectedMonthIsJuly && isBetweenJulyAndDecember) || (fiscalMonth <  selectedMonthIsJuly && isBetweenJanuaryAndJune);

const isPassedMonthAugust = (fiscalMonth > selectedMonthIsAugust && isBetweenJulyAndDecember) || (fiscalMonth <  selectedMonthIsAugust && isBetweenJanuaryAndJune);

const isPassedMonthSeptember = (fiscalMonth > selectedMonthIsSeptember && isBetweenJulyAndDecember) || (fiscalMonth <  selectedMonthIsSeptember && isBetweenJanuaryAndJune);

const isPassedMonthOctober = (fiscalMonth > selectedMonthIsOctober && isBetweenJulyAndDecember) || (fiscalMonth <  selectedMonthIsOctober && isBetweenJanuaryAndJune);

const isPassedMonthNovember = (fiscalMonth > selectedMonthIsNovember && isBetweenJulyAndDecember) || (fiscalMonth <  selectedMonthIsNovember && isBetweenJanuaryAndJune);

const isPassedMonthDecember =  (fiscalMonth > selectedMonthIsDecember && isBetweenJulyAndDecember) || (fiscalMonth <  selectedMonthIsDecember && isBetweenJanuaryAndJune);


const isPassedMonthJanuary =  (fiscalMonth > selectedMonthIsJanuary && isBetweenJanuaryAndJune);

const isPassedMonthFebruary = (fiscalMonth > selectedMonthIsFebruary && isBetweenJanuaryAndJune);

const isPassedMonthMarch = (fiscalMonth > selectedMonthIsMarch && isBetweenJanuaryAndJune);

const isPassedMonthApril = (fiscalMonth > selectedMonthIsApril && isBetweenJanuaryAndJune);

const isPassedMonthMay = (fiscalMonth > selectedMonthIsMay && isBetweenJanuaryAndJune);

const isPassedMonthJune =  (fiscalMonth > selectedMonthIsJune && isBetweenJanuaryAndJune);



      let newFilteredData = []; 
      const filteredContainersPurchasedPastyear = data.filter(item => item.purchasetypeid === 1 && item.year.fyname < fiscalYear && 
        (item.july !== null || item.august !== null  ||  item.september !== null
          || item.october !== null  ||  item.november !== null  
          ||  item.december !== null ||  item.january !== null 
          ||  item.february !== null  ||  item.march !== null 
          ||  item.april !== null  ||  item.may !== null 
          ||  item.june !== null)) ;
      
      const pastYearsPurchases = filteredContainersPurchasedPastyear.map(item => item.itempurchasedname);


      const filteredPurchasedCurrentYearJuly = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.july !== null && isPassedMonthJuly);
      const filteredPurchasedCurrentYearAgust = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.august !== null && isPassedMonthAugust);
      const filteredPurchasedCurrentYearSeptember = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.september !== null && isPassedMonthSeptember );
      const filteredPurchasedCurrentYearOctober = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.october !== null && isPassedMonthOctober  );
      const filteredPurchasedCurrentYearNovember = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.november !== null && isPassedMonthNovember  ) ;
      const filteredPurchasedCurrentYearDecember = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.december !== null  && isPassedMonthDecember ) ;
      const filteredPurchasedCurrentYearJanuary = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.january !== null && isPassedMonthJanuary ) ;
      const filteredPurchasedCurrentYearFebruary = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.february !== null && isPassedMonthFebruary  ) ;
      const filteredPurchasedCurrentYearMarch = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.march !== null && isPassedMonthMarch ) ;
      const filteredPurchasedCurrentYearApril = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.april !== null && isPassedMonthApril ) ;
      const filteredPurchasedCurrentYearMay = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.may !== null && isPassedMonthMay ) ;
      const filteredPurchasedCurrentYearJune = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.june !== null && isPassedMonthJune  ) ;
      newFilteredData = newFilteredData.concat(filteredContainersPurchasedPastyear,filteredPurchasedCurrentYearJuly,filteredPurchasedCurrentYearAgust,filteredPurchasedCurrentYearSeptember,filteredPurchasedCurrentYearOctober,
        filteredPurchasedCurrentYearNovember,filteredPurchasedCurrentYearDecember,filteredPurchasedCurrentYearJanuary,filteredPurchasedCurrentYearFebruary,
        filteredPurchasedCurrentYearMarch,filteredPurchasedCurrentYearApril,filteredPurchasedCurrentYearMay,filteredPurchasedCurrentYearJune);
      //const fiscalYears = newFilteredData.map(item => item.itempurchasedid_id);

      // Create a set to keep unique values
    const uniqueItemIdsSet = new Set(newFilteredData.map(item => item.itempurchasedname));
    
    // Convert the set back to an array
    const uniqueItemIdsArray = Array.from(uniqueItemIdsSet);

      this.setState({ purchasedContainers: uniqueItemIdsArray});
    })
    .catch(error => {
      console.error("Error fetching fiscal years:", error);
    });
}

fetchSapcodeNames() {
  axiosService.get('/defaultproductscreate/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const SapcodeNames = filteredData.map(item => item.sapcode);

      const sapcodeToProductDescriptionMap = {};
      filteredData.forEach(item => {
        sapcodeToProductDescriptionMap[item.sapcode] = item.productdescription;
      });

      this.setState({ SapcodeNames: SapcodeNames,SapcodeDescriptionNames:sapcodeToProductDescriptionMap  });
    })
    .catch(error => {
      console.error("Error fetching product sapcode:", error);
    });
}

findProductDescriptionForSapcode(sapcode) {
  const productDescriptionMap = this.state.SapcodeDescriptionNames;
  return productDescriptionMap[sapcode] || "Product not found";
}

componentDidMount(){
  this.refreshList();
  this.refreshListContainersValues();
  this.fetchContainerNames();
  this.fetchProductNames();
  this.fetchPurchasedContainers();
  this.fetchSapcodeNames();
}

changeNumberitems =(e)=>{
  this.setState({numberitems:e.target.value});
}

changeContainerDescription =(e)=>{
  this.setState({containerdescription:e.target.value});
}


resetSelect = () => {
  setTimeout(() => {
    this.setState({ selectedContainer: this.state.containerdescription });
    this.setState({ selectedProduct: this.state.productdescription });
  }, 0);
};

addClick(){
  this.resetSelect();
  this.setState({
      modalTitle:"Build Container",
      containercontentid:0,
      numberitems: "",
      containerdescription:"",
      containerid:0,
      productdescription:"",
      productid:0,
      isEditClicked: false,
  });
}
editClick(dep){
  this.resetSelect();
  this.setState({
      modalTitle:"Edit ContainerContent",
      containercontentid:dep.containercontentid,
      numberitems:dep.numberitems,
      containerdescription:dep.container.containerdescription,
      containerid:dep.container.containerid,
      productdescription:dep.product.productdescription,
      productid:dep.product.productid,
      initialNumberitems:dep.numberitems,
      initialContainerdescription:dep.container.containerdescription,
      initialProductdescription:dep.product.productdescription,
      isEditClicked: true,
  });
}

createClick() {
  const { numberitems, containerdescription, productdescription} = this.state;

  if (!numberitems) {
    alert('Number items is required');
    return;
  }

  if (!containerdescription) {
    alert('Container is required');
    return;
  }

  if (!productdescription) {
    alert('Product is required');
    return;
  }

  axiosService.post('/containerscontentcreate/', {
    containerdescription: containerdescription,
    productdescription:productdescription,
    numberitems: numberitems
  })
    .then(result => {
      alert('Product added to container  ');
      this.refreshList();
      const modalEl = document.getElementById('exampleModal');
      const BootstrapModal = window.bootstrap && window.bootstrap.Modal ? window.bootstrap.Modal : null;
      const bsModal = modalEl && BootstrapModal ? (BootstrapModal.getInstance(modalEl) || new BootstrapModal(modalEl)) : null;
      if (bsModal && typeof bsModal.hide === 'function') bsModal.hide();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}

updateClick(id) {

  const {  numberitems, containerdescription, productdescription, initialNumberitems, initialContainerdescription, initialProductdescription } = this.state;

   // Check if any changes are detected
   if (
    numberitems === initialNumberitems &&
    containerdescription === initialContainerdescription &&
    productdescription === initialProductdescription
  ) {
    alert('No changes detected');
    return;
  }
  if (!numberitems) {
    alert('Number items is required');
    return;
  }

  if (!containerdescription) {
    alert('Container is required');
    return;
  }

  if (!productdescription) {
    alert('Product is required');
    return;
  }

  
  axiosService.patch('/containerscontent/' + id + '/', {
    containercontentid: this.state.containercontentid,
    containerdescription: this.state.containerdescription,
    numberitems:this.state.numberitems,
    productdescription: this.state.productdescription
  })
    .then((result) => {
      alert('Update successful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch((error) => {
      alert('Failed');
    });
}


deleteClick(id) {
  if (window.confirm('Are you sure?')) {
    axiosService.delete('/containerscontent/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        window.location.reload(); // Refresh the page
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      containerscontent,
      modalTitle,
      containercontentid,
      numberitems,
      productdescription,
      containerdescription,
      loading,
      purchasedContainers,
      containerid,

      containersvalues,
      containervalueid_o,
      yearid_o,
		  fyname_o,
      containerid_o,
		  containerdescription_o,
      july_o,
      august_o,
      september_o,
      november_o,
      december_o,
      january_o,
      february_o,
      march_o,
      april_o,
      may_o,
      june_o,
  }=this.state;

 
  const isItemPurchased = purchasedContainers.includes(containerdescription);

  return(
<div className="scrollable-container">
<MyPage />
<SubTabsParameters />
<button type="button"
disabled={!isSuperAdmin()}
className="btn btn-primary m-2 float-end"
data-bs-toggle="modal"
data-bs-target="#exampleModal"
onClick={()=>this.addClick()}
style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
>
  Build Container
</button>

<div style={{ textAlign: 'left', fontWeight: 'bold',padding:"10px", fontSize: "14px" }}>
      Containers Content
    </div>
<div className="table-container">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
      onChange={this.changeContainerIdFilter}
      style={{ width: "100px", height:"30px" ,fontSize: "12px"}}
      placeholder="Filter"/>

      </div>
      ContainerID
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
          <select
            className="form-select"
            value={this.state.ContainerDescriptionFilter}
            onChange={this.changeContainerDescriptionFilter}
            style={{ width: "400px", height:"30px" ,fontSize: "12px"}}
          >
            <option value="">Select a container</option>
            {this.state.containerNames.map((container) => (
              <option key={container} value={container}>
                {container}
              </option>
            ))}
          </select>
      </div>
      Container
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
      onChange={this.changeProductIdFilter}
      style={{ width: "100px", height:"30px" ,fontSize: "12px"}}
      placeholder="Filter"/>

      </div>
      Product SAP Code/ SKU
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
          <select
            className="form-select"
            value={this.state.productdescription}
            onChange={this.changeProductDescriptionFilter}
            style={{ width: "400px", height:"30px" ,fontSize: "12px"}}
          >
            <option value="">Select a product</option>
            {this.state.productNames.map((product) => (
              <option key={product} value={product}>
                {product}
              </option>
            ))}
          </select>
      </div>
      Product
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">

      </div>
      NumberItems
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {containerscontent.map(dep=>
      <tr key={dep.containercontentid} className="row-hover">
          <td className="table-text">{dep.containerid}</td>
          <td className="table-text">{dep.container.containerdescription}</td>
          <td className="table-text">{dep.product.sapcode}</td>
          <td className="table-text">{dep.product.productdescription}</td>
          <td className="table-text">{dep.numberitems}</td>
          <td className="table-text">
          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          onClick={()=>this.deleteClick(dep.containercontentid)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash-fill" viewBox="0 0 16 16">
              <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
              </svg>
          </button>

          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>

<div style={{ textAlign: 'left', fontWeight: 'bold',padding:"10px", fontSize: "14px" }}>
      Containers Values
    </div>
<div className="table-container">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
      onChange={this.changeFiscalYearNameOFilter}
      style={{ width: "100px", height:"30px" ,fontSize: "12px"}}
      placeholder="Filter"/>

      </div>
      Fiscal Year
  </th>


  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
      onChange={this.changeContainerIdOFilter}
      style={{ width: "100px", height:"30px" ,fontSize: "12px"}}
      placeholder="Filter"/>

      </div>
      ContainerID
  </th>


  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
      onChange={this.changeContainerDescriptionOFilter}
      style={{ width: "200px", height:"30px" ,fontSize: "12px"}}
      placeholder="Filter"/>

      </div>
      Container Description
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jul
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Aug
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Sep
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Oct
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Nov
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Dec
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jan
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Feb
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Mar
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Apr
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      May
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jun
  </th>

</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {containersvalues.map(dep=>
      <tr key={dep.containervalueid_o} className="row-hover">
          <td className="table-text">{dep.fyname_o}</td>
          <td className="table-text">{dep.containerid_o}</td>
          <td className="table-text">{dep.containerdescription_o}</td>
          <td className="table-text">{dep.july_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.july_o) : 'N/A'}</td>
<td className="table-text">{dep.august_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.august_o) : 'N/A'}</td>
<td className="table-text">{dep.september_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.september_o) : 'N/A'}</td>
<td className="table-text">{dep.october_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.october_o) : 'N/A'}</td>
<td className="table-text">{dep.november_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.november_o) : 'N/A'}</td>
<td className="table-text">{dep.december_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.december_o) : 'N/A'}</td>
<td className="table-text">{dep.january_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.january_o) : 'N/A'}</td>
<td className="table-text">{dep.february_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.february_o) : 'N/A'}</td>
<td className="table-text">{dep.march_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.march_o) : 'N/A'}</td>
<td className="table-text">{dep.april_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.april_o) : 'N/A'}</td>
<td className="table-text">{dep.may_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.may_o) : 'N/A'}</td>
<td className="table-text">{dep.june_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.june_o) : 'N/A'}</td>

      </tr>
      )}
</tbody>
 )
}
</table>
</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }}>{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      
      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Container</span>
          <select
            className="form-select"
            value={this.state.containerdescription}
            onChange={(event) => this.setState({ containerdescription: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }}
          >
            <option value="">Select a container</option>
            {this.state.containerNames.map((container) => (
              <option key={container} value={container}>
                {container} 
              </option>
            ))}
          </select>
        </div>
      


{ !isItemPurchased  && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Product</span>
  <input
    list="sapcodeOptions"
    className="form-control"
    value={this.state.sapcode}
    onChange={(event) => {
      const selectedSapcode = event.target.value;
      this.setState({ sapcode: selectedSapcode });
      const productdescription = this.findProductDescriptionForSapcode(selectedSapcode);
      this.setState({ productdescription: productdescription });
    }}
    disabled={this.state.isEditClicked}
    style={{ fontSize: "12px" }}
    placeholder="Type or select SAPCODE"
  />
  <datalist id="sapcodeOptions">
    {this.state.SapcodeNames.map((sapcode) => (
      <option key={sapcode} value={sapcode} />
    ))}
  </datalist>
</div>
 )}

{ !isItemPurchased  && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Product Name</span>
  <input
    type="text"
    className="form-control"
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>
 )}

        { !isItemPurchased  && (
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Number Items</span>
          <input
            type="number"
            className="form-control"
            value={numberitems}
            onChange={this.changeNumberitems}
            style={{ fontSize: "12px" }}
          />
        </div>
        )}

{isItemPurchased && (
  <div className="alert alert-info" role="alert">
    This container has already been purchased. You cannot make changes. Please create another one.
  </div>
)}



        {containercontentid === 0 && !isItemPurchased ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.createClick()}>
            Build Container
          </button>
        ) : null}

        {containercontentid !== 0 && !isItemPurchased ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.updateClick(containercontentid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>
</div>
  )
}
}

